
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ApplicationList } from "./ApplicationList";
import { useUserRoles } from "@/hooks/useUserRoles";
import { useIsMobile } from "@/hooks/use-mobile";

interface ApplicationTabsProps {
  applications: any[];
  isLoading: boolean;
}

export const ApplicationTabs = ({ applications, isLoading }: ApplicationTabsProps) => {
  const [activeTab, setActiveTab] = useState("all");
  const { isAdmin, roles } = useUserRoles();
  const isMobile = useIsMobile();
  
  // Only admins and non-guard/client users can manage applications
  const canManageApplications = isAdmin || !['guard', 'client'].includes(roles?.[0] || '');

  const handleTabChange = (value: string) => {
    setActiveTab(value);
  };

  const handleApplicationDeleted = () => {
    // Force refetch applications
    window.location.reload();
  };

  return (
    <Tabs defaultValue="all" onValueChange={handleTabChange} className="w-full">
      <TabsList className={`${isMobile ? "w-full grid grid-cols-2" : ""} bg-primary-100 text-primary-700`}>
        <TabsTrigger 
          value="all" 
          className={`${isMobile ? "text-sm py-1.5" : ""} data-[state=active]:bg-primary data-[state=active]:text-white`}
        >All Work Applications</TabsTrigger>
        <TabsTrigger 
          value="pending" 
          className={`${isMobile ? "text-sm py-1.5" : ""} data-[state=active]:bg-primary data-[state=active]:text-white`}
        >Pending Review</TabsTrigger>
      </TabsList>
      <TabsContent value="all" className="mt-4 md:mt-6">
        <ApplicationList 
          applications={applications} 
          isLoading={isLoading} 
          status="all" 
          onApplicationDeleted={handleApplicationDeleted}
          isAdmin={canManageApplications}
        />
      </TabsContent>
      <TabsContent value="pending" className="mt-4 md:mt-6">
        <ApplicationList 
          applications={applications} 
          isLoading={isLoading} 
          status="pending" 
          onApplicationDeleted={handleApplicationDeleted}
          isAdmin={canManageApplications}
        />
      </TabsContent>
    </Tabs>
  );
};
